import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { cn } from "../lib/utils";
import DeletedBar from "./DeletedBar";

interface NavProps {
  light?: boolean;
  right?: React.ReactNode;
  className?: string;
  blank?: boolean;
  accountStatusBar?: boolean; // New prop to account for status bar
}

export const Nav = ({ light, right, className, blank }: NavProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const color = light ? "#FCFCFC" : "#112A29";

  if (blank) {
    return (
      <>
        <div className={cn("h-10", className)}></div>
        <DeletedBar />
      </>
    );
  }

  return (
    <>
      <div
        className={cn(
          "w-full flex justify-between items-center pt-5",
          "status-bar-padding",
          className
        )}
      >
        <div
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => navigate(-1)}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.80903 14.3885L0.815979 10.3954L4.80903 6.40234"
              stroke={color}
              strokeWidth="0.833333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M0.815979 10.3984H19.184"
              stroke={color}
              strokeWidth="0.833333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <div
            className={cn("text-16 font-medium text-default")}
            style={{ color }}
          >
            {t("common.back")}
          </div>
        </div>
        <div className="flex items-center gap-3">{right}</div>
      </div>
      <DeletedBar />
    </>
  );
};
